import { createTheme } from '@mui/material/styles';

export default createTheme({
	typography: {
		h1: {
			fontSize: '4.5rem',
		},
	},
});
